import { Component } from '@angular/core';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-optische-folgereaktion-epilog',
	templateUrl: './optische-folgereaktion-epilog.component.html',
	styleUrls: ['./optische-folgereaktion-epilog.component.scss']
})
export class OptischeFolgereaktionEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<ReadonlyMap<number, number>>) {}
}
